<template>
  <div>
    <transition name="fade_down" mode="out-in">
      <div v-if="quizFiles.length || assetFiles.length">
        <section v-if="quizFiles.length">
          <h3 class="px-4 text-lg">Quiz Assets</h3>
          <table class="relative min-w-full mb-8 divide-y divide-gray-300">
            <thead class="bg-slate-200 px-4 py-2 mb-4 uppercase font-semibold">
              <tr>
                <th scope="col" class="py-3.5 px-4 text-left text-sm font-semibold text-gray-900 border-0">
                  <div class="inline-flex items-center gap-x-2">
                    <input type="checkbox" v-model="selectAllQuiz" class="form-checkbox h-4 w-4">
                    <span class="text-sm leading-none">Title</span>
                  </div>
                </th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Module</th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Type</th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Size</th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Action</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-200">
              <asset-browser-file v-for="file in quizFiles" :key="file.id" :file="file" :checked="selectAllQuiz"
                :selectedFileCount="selectedFileCount" @updateFileCount="emitUpdateFileCount" />
            </tbody>
          </table>
        </section>

        <section v-if="assetFiles.length">
          <h3 class="px-4 text-lg" v-if="quizFiles.length">Course Assets</h3>
          <table class="relative min-w-full divide-y divide-gray-300">
            <thead class="bg-slate-200 px-4 py-2 mb-4 uppercase font-semibold">
              <tr>
                <th scope="col" class="py-3.5 px-4 text-left text-sm font-semibold text-gray-900 border-0">
                  <div class="inline-flex items-center gap-x-2">
                    <input type="checkbox" v-model="selectAllFiles" class="form-checkbox h-4 w-4">
                    <span class="text-sm leading-none">Title</span>
                  </div>
                </th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Module</th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Type</th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Size</th>
                <th scope="col" class="py-3.5 px-4 text-left text-sm leading-none font-semibold text-gray-900 border-0">
                  Action</th>
              </tr>
            </thead>
            <tbody v-if="assetFiles.length" class="divide-y divide-slate-200">
              <asset-browser-file v-for="file in assetFiles" :key="file.id" :file="file" :checked="selectAllFiles"
                :selectedFileCount="selectedFileCount" @updateFileCount="emitUpdateFileCount" />
            </tbody>
          </table>
        </section>
      </div>

      <p v-else-if="message" class="border border-yellow-400 bg-yellow-100 py-2 text-lg px-4">{{ message }}</p>

      <vue-simple-spinner v-else message="Retrieving File List" size="medium" line-bg-color="#eee"
        line-fg-color="#05b284" class="text-center mt-10" />
    </transition>
  </div>
</template>

<script>
import AssetBrowserFile from './AssetBrowserFile.vue'

export default {
  name: 'assetBrowserFiles',

  props: {
    module: {
      type: Object,
      required: true
    },
    selectedFileCount: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      files: [],
      modulefiles: [],
      message: null,
      selectAllQuiz: false,
      selectAllFiles: false,
    }
  },

  watch: {
    selectedFileCount(newCount) {
      if (newCount === 0) {
        this.selectAllFiles = false
        this.selectAllQuiz = false
      }
    }
  },

  computed: {
    quizFiles() {
      let fileIds = new Set();
      return [...this.modulefiles, ...this.files].filter((file) => {
        if (fileIds.has(file.id) || file.type !== 'quiz') {
          return false
        }

        fileIds.add(file.id)
        return true
      })
    },
    assetFiles() {
      let fileIds = new Set();
      return [...this.modulefiles, ...this.files].filter((file) => {
        if (fileIds.has(file.id) || file.type !== 'asset') {
          return false
        }

        fileIds.add(file.id)
        return true
      })
    },
  },

  components: {
    AssetBrowserFile
  },

  mounted() {
    fetch(`/api/v1/school/module/${this.module.id}?` + new URLSearchParams({
      include: ['files', 'modulefiles']
    }))
      .then(response => {
        if (response.ok) return response.json();

        throw new Error("There was an error retrieving the file list.");
      })
      .then(successResp => {
        this.files = successResp.files.data
        this.modulefiles = successResp.modulefiles.data

        if (this.files.length < 1 && this.modulefiles.length < 1) {
          this.message = "No files were found."
        }
      })
      .catch(error => {
        this.message = error
      });
  },

  methods: {
    emitUpdateFileCount(count) {
      this.$emit('updateFileCount', count)
    }
  },
}
</script>
